// shared/contexts/NavigationContext.tsx

import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

interface INavigationContextData {
  previousUrl: string;
  goBack: (defaultRoute?: string) => void;
}

const NavigationContext = createContext({} as INavigationContextData);

export const NavigationProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {

  const location = useLocation();
  const navigate = useNavigate();

  const [previousUrl, setPreviousUrl] = useState('/');

  useEffect(() => {

    const currentUrl =
      location.pathname + location.search;

    const currentIsDetail =
      currentUrl.includes('/detalhe');

    const currentStoredUrl =
      sessionStorage.getItem('CURRENT_URL');

    // Salva a última rota válida antes de entrar no detalhe
    if (
      currentStoredUrl &&
      !currentIsDetail
    ) {

      sessionStorage.setItem(
        'PREVIOUS_URL',
        currentStoredUrl
      );

      setPreviousUrl(currentStoredUrl);
    }

    // Sempre atualiza a rota atual
    sessionStorage.setItem(
      'CURRENT_URL',
      currentUrl
    );

  }, [location]);

  const goBack = (defaultRoute = '/') => {

    const storedPreviousUrl =
      sessionStorage.getItem('PREVIOUS_URL');

    navigate(
      storedPreviousUrl || defaultRoute
    );
  };

  const value = useMemo(() => ({
    previousUrl,
    goBack,
  }), [previousUrl]);

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => {
  return useContext(NavigationContext);
};